import { IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import { removing } from "../../../redux/slices/orderSlice";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { pink } from '@mui/material/colors';
import './style.scss';

const Checkout = () => {
    const dispatch = useAppDispatch();

    const { selected, goods, isHight } = useAppSelector((state: RootState) => state.orderSlice);
    
    const getItems = goods
    .filter((item) => selected.includes(item.categoryId))
    .sort((a, b) => selected.indexOf(a.categoryId) - selected.indexOf(b.categoryId))
    .map((item) => {
        if(item.count>0) {
            if(item.isActivatePromo) {
                return (
                    <div className="checkout_item" key={item.categoryId}>
                        <span className="checkout_item_title">{item.title}</span>
                        <span className="checkout_item_count">{item.count}x</span>
                        <div className="checkout_item_prices">
                            <span className="checkout_item_prices_old">{((item.count * Number(item.prices.standart))/100).toFixed(2)} Br</span>
                            <span className="checkout_item_prices_current">{((item.count * Number(item.prices.promo))/100).toFixed(2)} Br</span>
                        </div>
                        <IconButton aria-label="delete" size="small" onClick={() => dispatch(removing(item.categoryId))}>
                            <DeleteIcon fontSize="small"/>
                        </IconButton>
                    </div>
                );
            } else {
                return (
                    <div className="checkout_item" key={item.categoryId}>
                        <span className="checkout_item_title">{item.title}</span>
                        <span className="checkout_item_count">{item.count}x</span>
                        <div className="checkout_item_prices">
                            <span className="checkout_item_prices_current">{((item.count * Number(item.prices.standart))/100).toFixed(2)} Br</span>
                        </div>
                        <IconButton aria-label="delete" size="small" onClick={() => dispatch(removing(item.categoryId))}>
                            <DeleteIcon fontSize="small"/>
                        </IconButton>
                    </div>
                );
            }
        } else {
            return null;
        }
    });
      
    return (
        <div className="checkout order-mode_checkout">
            <div className="checkout_container">
                <div className="checkout_wrapper">
                    {getItems}
                    {isHight && (
                        <div className="checkout_warning">
                            <WarningAmberRoundedIcon fontSize="small" sx={{ color: pink[500] }}/>
                            <span className="checkout_warning_text">Некоторые билеты распроданы и теперь недоступны для продажи.</span>
                        </div>
                    )}
                    
                </div>
            </div>
        </div>
    );
}

export default Checkout;